<template>
    <div v-if="isBeforeDeadline&&isAfterLaunchDate" class="alert-bar">
			<!-- <div class="container"> -->
				<div class="alert-bar-inner">
              <!-- <p>2026 Student Volunteer Applications are Open Now!</p> -->
              <p v-if="!pastTLAppDeadline">Team Leader Applications Are Due <strong>{{
                formattedDate(applicationTlEndDate) }}</strong></p>
              <p v-else>Team Leader Applications Are Now Closed</p>
              <p v-if="isBeforeDeadline">Student Volunteer Applications Are Due <strong>{{
                formattedDate(applicationEndDate) }}</strong></p>
				</div>
			</div>
		<!-- </div> -->
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'Banner',
  data () {
    return {}
  },
  methods: {
    formattedDate: function (date) {
      return moment(date).tz('UTC').format('D MMMM YYYY')
    }
  },
  computed: {
    ...mapState(['applicationLaunchDate', 'applicationTlEndDate', 'applicationEndDate']),
    ...mapGetters(['isBeforeDeadline', 'isAfterDeadline', 'pastTLAppDeadline', 'isAfterLaunchDate'])
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Banner.vue